module.exports = __webpack_public_path__ + "img/background-organization-setup.23a84711.jpg";